/* eslint-disable camelcase */
export default {
  error_placing: 'Ошибка при размещении ребенка: {0}',
  placement_disabled: 'Ручное размещение отключено',

  place_confirm_header: 'Вы уверены?',
  place: 'Разместить',
  under: 'под',
  left_leg: '- левое плечо?',
  right_leg: '- правое плечо?',

  lowest_left: 'Нижний левый',
  lowest_right: 'Нижний правый',
  spillover_is_left: 'Ваша ветка перелива - ЛЕВАЯ',
  spillover_is_right: 'Ваша ветка перелива - ПРАВАЯ',
  lowest_pos: 'Нижний {0}',
  back_to_me: 'Мой аккаунт',

  country_flags: {
    tooltip: 'Страна: {0}',
    unknown_country: 'Неизвестная страна'
  }
};
